// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { Tenancy } from './Tenancy';
/**
 * 租户等级 实体类
 * 租户等级，不同等级享受不同的权利
 */
export class TenancyLevel extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 编码 : 编码 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 描述 : 描述 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 是否缺省 : 是否缺省，true租户创建时的缺省等级 */
  private _isDefault: boolean;

  /** 设置：是否缺省 */
  public get isDefault() {
    return this._isDefault;
  }

  /** 获取：是否缺省 */
  public set isDefault(value: boolean) {
    this._isDefault = value;
  }

  /** 租户 */
  private _tenancies: Array<Tenancy>;

  /** 获取：租户 */
  public get tenancies() {
    return this._tenancies;
  }

  /** 设置：租户 */
  public set tenancies(value: Array<Tenancy>) {
    this._tenancies = value;
  }

  /** 上一级 的ID */
  private _upLevel_ID: string;

  /** 获取：上一级 的ID */
  public get upLevel_ID() {
    return this._upLevel_ID;
  }

  /** 设置：上一级 的ID */
  public set upLevel_ID(value: string) {
    this._upLevel_ID = value;
  }

  /** 上一级  */
  private _upLevel: TenancyLevel;

  /** 获取：上一级  */
  public get upLevel() {
    return this._upLevel;
  }

  /** 设置：上一级  */
  public set upLevel(value: TenancyLevel) {
    this._upLevel = value;
    if (value !== null) {
      this.upLevel_ID = value.id;
    } else {
      this.upLevel_ID = '';
    }
  }

  /** 下一级 */
  private _downLevels: Array<TenancyLevel>;

  /** 获取：下一级 */
  public get downLevels() {
    return this._downLevels;
  }

  /** 设置：下一级 */
  public set downLevels(value: Array<TenancyLevel>) {
    this._downLevels = value;
  }

  constructor() {
    super();
    this._name = '';
    this._code = '';
    this._description = '';
    this._isDefault = false;
    this._tenancies = new Array<Tenancy>();
    this._upLevel_ID = '';
    this._upLevel = null;
    this._downLevels = new Array<TenancyLevel>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: TenancyLevel, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.code = element.code;
      this.description = element.description;
      this.isDefault = element.isDefault;
      this.upLevel_ID = element.upLevel_ID;
      if (hasReference && element.upLevel !== null) {
        this.upLevel = element.upLevel;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.code = json.Code;
    this.description = json.Description;
    this.isDefault = json.IsDefault;
    if (json.Tenancies && json.Tenancies.length > 0) {
      json.Tenancies.forEach((element: any) => {
        const tenancy = Tenancy.Create(element);
        // tenancy.tenancyLevel = this;
        this.tenancies.push(tenancy);
      });
    }
    this.upLevel_ID = json.UpLevel_ID;
    // if (json.UpLevel !== null) {
    //   this.upLevel = TenancyLevel.Create(json.UpLevel);
    // }
    if (json.DownLevels && json.DownLevels.length > 0) {
      json.DownLevels.forEach((element: any) => {
        const tenancyLevel = TenancyLevel.Create(element);
        // tenancyLevel.upLevel = this;
        this.downLevels.push(tenancyLevel);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Code = this.code;
    json.Description = this.description;
    json.IsDefault = this.isDefault;
    if (this.tenancies && this.tenancies.length > 0) {
      json.Tenancies = [];
      this.tenancies.forEach((element) => {
        json.Tenancies.push(element.toJson());
      });
    }
    json.UpLevel_ID = this.upLevel_ID;
    if (this.downLevels && this.downLevels.length > 0) {
      json.DownLevels = [];
      this.downLevels.forEach((element) => {
        json.DownLevels.push(element.toJson());
      });
    }
  }

  static Create(json: any): TenancyLevel {
    const tenancyLevel = new TenancyLevel();
    tenancyLevel.Deserialize(json);
    tenancyLevel.json = json;
    return tenancyLevel;
  }
}
